import { render, staticRenderFns } from "./HorseSummary.vue?vue&type=template&id=74e8efd2&"
import script from "./HorseSummary.vue?vue&type=script&lang=js&"
export * from "./HorseSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports